var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDragHandle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.32633,
    cy: 2.18749,
    rx: 1.60417,
    ry: 1.60417,
    fill: "current"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.32633,
    cy: 7,
    rx: 1.60417,
    ry: 1.60417,
    fill: "current"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.32633,
    cy: 11.8125,
    rx: 1.60417,
    ry: 1.60417,
    fill: "current"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.6735,
    cy: 2.18749,
    rx: 1.60417,
    ry: 1.60417,
    fill: "current"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.6735,
    cy: 7,
    rx: 1.60417,
    ry: 1.60417,
    fill: "current"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.6735,
    cy: 11.8125,
    r: 1.60417,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDragHandle2);
export default __webpack_public_path__ + "static/media/ic_drag_handle2.b343fab258428c93b93b268221169c00.svg";
export { ForwardRef as ReactComponent };